<template>
	<div class="max-w-[853px] mx-auto">
<!--		<span v-if="!inRelation" class="font-semibold text-[20px] xl:text-[24px]">Sonda {{ hasPollEnded ? '(zakończona)' : '' }}</span>-->
		<div :class="[{'!bg-zt-light-transparent !font-medium border-zt-light/60 !text-sm px-[10px] xl:px-[18px] !py-4 xl:!py-2 xl:!text-base' : inRelation},
		              {'mt-[9px]': !inRelation, '!px-[58px]' : window.size.desktop && inRelation}]"
          class="bg-[#313D51] py-4 px-2.5 rounded-zt text-[16px] relative xl:text-base xl:px-10 xl:py-4">
      <div v-if="inRelation" class="absolute left-0 content-[''] w-[2px] h-[30px] rounded-full top-1/2 -translate-y-1/2
                        bg-zt-red rounded-tr-md rounded-br-md rounded-tl-none rounded-bl-none"></div>
			<div  class="pb-2 xl:flex items-center xl:pb-4 xl:mx-6"
           :class="{ 'xl:!pb-1.5 xl:!mx-0' : inRelation }">
        <span class="font-[500] xl:text-sm">{{ pollData.title }} <span class="font-[300]">{{ hasPollEnded ? '(Zakończona)' : '' }}</span></span>
        <div v-if="window.size.desktop" class="ml-auto flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none"
            class="cursor-pointer zt-hover" @click.stop="handleRefreshClick" :class="{'pointer-events-none opacity-50' : hasPollEnded}">
            <path d="M1.30394 11.4544C1.19515 11.4545 1.08849 11.4242 0.995899 11.3671C0.903312 11.31 0.828458 11.2282 0.779719 11.131C0.0877839 9.75427 -0.152143 8.19437 0.0941073 6.67339C0.340357 5.1524 1.06023 3.74789 2.1512 2.65986C5.0098 -0.199121 9.66136 -0.199121 12.52 2.65986C12.6267 2.77037 12.6857 2.91838 12.6844 3.07201C12.6831 3.22564 12.6215 3.3726 12.5128 3.48124C12.4042 3.58988 12.2572 3.6515 12.1036 3.65284C11.95 3.65417 11.8019 3.59511 11.6914 3.48838C9.2887 1.08643 5.38245 1.08643 2.97972 3.48838C2.06313 4.40253 1.45835 5.58258 1.25152 6.86048C1.04468 8.13838 1.24634 9.44896 1.82777 10.6056C1.87261 10.6949 1.89386 10.7942 1.88949 10.894C1.88513 10.9939 1.85531 11.0909 1.80285 11.176C1.75039 11.2611 1.67705 11.3313 1.58979 11.38C1.50254 11.4288 1.40427 11.4544 1.30433 11.4544H1.30394Z" fill="#93A3BA"/>
            <path d="M7.33267 15.1729C6.36991 15.1747 5.41629 14.9862 4.52659 14.6183C3.6369 14.2504 2.82865 13.7104 2.14829 13.0292C2.09387 12.9748 2.05069 12.9102 2.02122 12.8391C1.99176 12.768 1.97658 12.6918 1.97656 12.6149C1.97654 12.5379 1.99168 12.4617 2.02112 12.3906C2.05055 12.3195 2.0937 12.2549 2.1481 12.2005C2.2025 12.146 2.26709 12.1029 2.33817 12.0734C2.40926 12.0439 2.48546 12.0287 2.56241 12.0287C2.63936 12.0287 2.71557 12.0439 2.78667 12.0733C2.85777 12.1027 2.92238 12.1459 2.97681 12.2003C5.37954 14.6022 9.28579 14.6022 11.6885 12.2003C12.6051 11.2861 13.2099 10.1061 13.4167 8.82817C13.6236 7.55027 13.4219 6.23969 12.8405 5.08308C12.7708 4.94415 12.7592 4.78324 12.8082 4.63573C12.8571 4.48823 12.9627 4.36623 13.1016 4.29655C13.2405 4.22688 13.4015 4.21526 13.549 4.26423C13.6965 4.3132 13.8185 4.41876 13.8881 4.55769C14.4489 5.67541 14.7143 6.91801 14.6591 8.16728C14.604 9.41655 14.2301 10.6309 13.573 11.6949C12.916 12.7588 11.9976 13.637 10.9053 14.2458C9.81304 14.8545 8.58315 15.1737 7.33267 15.1729Z" fill="#93A3BA"/>
            <path d="M9.60643 3.90927C9.45652 3.90852 9.3126 3.85034 9.20428 3.74669C9.09597 3.64305 9.0315 3.50183 9.02414 3.3521C9.01679 3.20236 9.0671 3.0555 9.16474 2.94174C9.26237 2.82798 9.3999 2.75597 9.54901 2.74052L11.4017 2.55576L11.0303 0.693648C11.0019 0.542067 11.0345 0.385421 11.1209 0.257684C11.2073 0.129946 11.3405 0.041415 11.4918 0.0112908C11.643 -0.0188334 11.8 0.0118777 11.9288 0.096764C12.0575 0.18165 12.1476 0.313867 12.1795 0.464741L12.6771 2.96201C12.6931 3.04218 12.6922 3.12481 12.6743 3.20458C12.6565 3.28436 12.6221 3.35952 12.5735 3.42523C12.5248 3.49093 12.463 3.54574 12.3919 3.58611C12.3208 3.62649 12.2421 3.65154 12.1607 3.65966L9.66542 3.90849C9.6455 3.90849 9.62596 3.90927 9.60643 3.90927Z" fill="#93A3BA"/>
            <path d="M3.05975 15.6975C2.92429 15.6974 2.79305 15.6503 2.68836 15.5644C2.58366 15.4784 2.51199 15.3588 2.48553 15.226L1.98787 12.7307C1.97188 12.6505 1.97286 12.5678 1.99073 12.488C2.00861 12.4082 2.04299 12.333 2.09167 12.2673C2.14035 12.2016 2.20224 12.1468 2.27337 12.1065C2.3445 12.0661 2.42329 12.0411 2.50467 12.033L4.99998 11.7842C5.15461 11.7686 5.30907 11.8152 5.42939 11.9135C5.54972 12.0119 5.62605 12.154 5.64159 12.3086C5.65713 12.4632 5.61061 12.6177 5.51226 12.738C5.41391 12.8583 5.27179 12.9347 5.11717 12.9502L3.26444 13.135L3.63553 14.9971C3.65248 15.0822 3.65032 15.1699 3.62922 15.2541C3.60811 15.3382 3.56859 15.4166 3.5135 15.4836C3.45842 15.5506 3.38914 15.6046 3.31067 15.6416C3.2322 15.6785 3.1465 15.6976 3.05975 15.6975Z" fill="#93A3BA"/>
          </svg>
          <span class="text-sm font-normal ml-1.5">
          Głosów: <span>{{ sumOfVotes }}</span>
        </span>
        </div>
			</div>
			<div class="flex flex-col gap-y-[6px] xl:gap-y-[11px] xl:mx-6"
           :class="{ 'xl:!mx-0 xl:!gap-y-2' : inRelation }">
        <div v-for="(option, index) in pollOptions" :key="option.id"
             :class="{ 'cursor-pointer zt-hover' : canUserVote, 'progress-selected' : option.id === selectedId || hasPollEnded,
                       'progress after:!bg-[#3A4B64]' : !canUserVote && option.id !== selectedId && !hasPollEnded, '!py-1' :inRelation }"
             :style="`--div-width: ${getWidthPercentage(option)}% `"
             class="w-full transition-all group flex gap-x-[18px] py-2.5 font-[300] border-2 border-[#415876] rounded-zt xl:py-[15px]"
             @click="selectOption(option.id, index)">
					<div class="z-10 flex items-center mr-2" :class="hasPollEnded ? '-ml-2.5 xl:pl-[6px] xl:-ml-0' : 'w-[15px] pl-[9px] xl:w-[36px] xl:pl-[18px]'">
            <svg v-if="option.id === selectedId && !hasPollEnded" class="shrink-0"
                xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="" :class="selectedId === option.id ? 'stroke-[#9B2733] fill-zt-red' : 'stroke-[#9B2733]'"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.3918 15.9467L5.30986 12.235L3.94922 13.4723L9.3918 18.4212L21.0545 7.81634L19.6938 6.5791L9.3918 15.9467Z" fill="white"/>
            </svg>
            <svg v-else-if="!hasPollEnded" class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <rect x="0.5" y="0.5" width="24" height="24" rx="12" fill="#313D51"/>
              <rect x="0.5" y="0.5" width="24" height="24" rx="12" stroke="#485C7A"/>
            </svg>
					</div>
					<div class="w-full z-10 flex gap-x-5 justify-between items-center xl:text-sm">
						<span>{{ option.title }}</span>
            <Transition name="slide-fade">
              <div v-if="!canUserVote" class="flex gap-x-[7px] items-center">
<!--                <span class="only-desktop text-sm font-medium text-zt-more">-->
<!--                  ({{ option.votes }})-->
<!--                </span>-->
                <span class="pr-5">
                  {{ sumOfVotes > 0 ? getWidthPercentage(option) : "0" }}%
                </span>
              </div>
            </Transition>
					</div>
				</div>
			</div>
      <div v-if="!canUserVote && window.size.mobile" class="text-center pt-2 flex justify-between xl:mx-6">
        <span class="text-sm font-normal xl:font-semibold">
          Zagłosowało: <span>{{ sumOfVotes }}</span>
        </span>
        <span class="text-zt-more underline zt-hover cursor-pointer text-sm"
              @click.stop="handleRefreshClick" :class="{'pointer-events-none opacity-50' : hasPollEnded}">
          Odśwież
        </span>
      </div>

      <div v-show="refreshIndicator"
           class="absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-center bg-zt-normal rounded-full p-2">
        <div class="spinner h-8 w-8 border-4" role="status">
          <span class="invisible">Wczytywanie...</span>
        </div>
      </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SinglePoll',
	inject: ['WP'],
	props: ['pollData', 'pollOptions'],
	data() {
		return {
			selectedId: 0,
			canUserVote: true,
      refreshIndicator: false,
		}
	},
  computed: {
    sumOfVotes() {
      return Object.values(this.pollOptions).reduce((t, {votes}) => t + +votes, 0);
    },
    hasPollEnded() {
      if (this.pollData.end_date) {
        const pollEndDate = DateTime.fromSQL(this.pollData.end_date).ts;
        const currentTime = DateTime.now().ts;
        return currentTime > pollEndDate;
      }
      return false;
    },
    inRelation() {
      return this.pollData.in_relation === '1';
    }
  },
	created() {
		this.checkCanUserVote();
		let interval = setInterval(() => {
			if (this.hasPollEnded) {
				this.canUserVote = false;
				clearInterval(interval);
			}
		}, 1000);
	},
	methods: {
		selectOption(option, index) {
			this.checkCanUserVote();
			if (!this.canUserVote) {
				return;
			}
			this.selectedId = option;
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_add_user_poll_vote',
					poll_id: this.pollData.id,
					option_id: option,
          commentary_id: this.pollData.postId,
				})
				.then(() => {
					this.pollOptions[index].votes = +this.pollOptions[index].votes + 1;
					this.canUserVote = false;
          this.$emit('refresh');
				});
		},
		checkCanUserVote() {
			if (this.hasPollEnded) {
				this.canUserVote = false;
				return;
			}
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_can_user_vote_in_poll',
					poll_id: this.pollData.id
				})
				.then((response) => {
					if (response.data.data !== true) {
						this.canUserVote = false;
						this.selectedId = response.data.data;
					}
				})
		},
		getWidthPercentage(option) {
			return Math.round((+option.votes / this.sumOfVotes) * 100);
		},
    handleRefreshClick() {
      this.$emit('refresh');
      this.refreshIndicator = true;
      setTimeout(() => this.refreshIndicator = false, 500);
    },
	},
}
</script>

<style scoped>
.progress:after,
.progress-selected:after {
  content: '\A';
  position: absolute;
  background: #3A4B64;
  background-size: contain;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: var(--div-width);
}

.progress, .progress-selected {
  position: relative;
  @apply overflow-hidden
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

</style>